<div class="empty-state-wrapper">
  @if (assistantData()?.isDefault) {
    <u-icon
      class="card-icon"
      [styles]="iconStyles"
      [model]="EMPTY_STATE_ICON"
      [styles]="{ fontSize: '25px', width: '147px', height: '113px' }"
    ></u-icon>
  } @else {
    <assistant-icon
      [model]="assistantData()"
      [iconStyles]="{ fontSize: '25px', width: '25px', height: '25px' }"
      [spriteEmojiSize]="32"
    ></assistant-icon>
  }

  <div class="chat-assistant-header">
    <div class="title">
      <ng-container *ngIf="assistantData()?.isDefault"> Ask me about anything in </ng-container>
      <div class="name">{{ assistantData()?.name }}</div>
    </div>
    <div class="info">
      <ng-container *ngTemplateOutlet="createdByInfo"></ng-container>
      <ng-container *ngTemplateOutlet="modelInfo"></ng-container>
      <ng-container *ngTemplateOutlet="webSearch"></ng-container>
    </div>
  </div>
  <div class="description">
    {{ assistantData()?.description }}
  </div>

  @if (showResumeLastThread()) {
    <u-button
      [versionNumber]="2"
      typeElement="secondary"
      [styleType]="'outlined'"
      fontIcon="clock"
      (onClick)="resumeLastThread()"
      [label]="'Resume last thread'"
      class="resume-last-thread"
    ></u-button>
  }

  <div class="margin-bottom"></div>

  @if (!assistantData()?.isDefault && assistantData()?.conversationStarterMessages?.length) {
    <card-list [cards]="assistantData().conversationStarterMessages" (onClickCard)="openNewChatWithConversationStarter($event)"></card-list>
  }
</div>
<ng-template #createdByInfo>
  <div class="creator-info-container">
    <avatar [url]="assistantData()?.createdByInfo?.avatar.imgUrl || assistantData()?.createdByInfo?.avatar.name" [size]="'20px'"></avatar>
    <div
      [pTooltip]="assistantData()?.createdByInfo?.avatar.isNameFromEmail ? assistantData()?.createdByInfo?.avatar.email : ''"
      tooltipPosition="top"
      tooltipStyleClass="u-tooltip"
    >
      {{ assistantData()?.createdByInfo?.description }} {{ assistantData()?.createdByInfo?.avatar.name }}
    </div>
  </div>
</ng-template>
<ng-template #modelInfo>
  <div class="info-line" *ngIf="modelName()">
    {{ modelName() }}
  </div>
</ng-template>
<ng-template #webSearch>
  <div class="info-line" *ngIf="assistantData()?.allowWebAccess">
    <u-icon
      [model]="{ type: 'font', value: 'icon-network' }"
      [styles]="{ fontSize: '16px', color: 'var(--color-text-tertiary)', lineHeight: '20px' }"
    ></u-icon>
    <span>Web</span>
  </div>
</ng-template>
